/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseError } from './BaseError';
const TokenRevokedExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([['tokenId', codecString, 'token_id']]), BaseError);
export class TokenRevokedException extends BaseError {
    static decode(input) {
        return TokenRevokedExceptionParser.decode(input).map(res => new TokenRevokedException(res));
    }
    static unsafeDecode(input) {
        return TokenRevokedException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TokenRevokedExceptionParser.encode(data);
    }
    static schema() {
        return TokenRevokedExceptionParser.schema();
    }
}
